'use strict';
import { Price } from '../finance';

function CottageComplex (item) {
  this.id = item.get('id');
  this.name = item.get('name');
  this.uri = item.get('uri');

  this.typeName = 'Коттеджный посёлок';
  this.typeShortName = 'КП';

  this.address = item.get('location');
  this.deadline = item.get('deadline');
  this.price = new Price(item.get('priceMin'));
  this.mainPhoto = item.getIn(['mainPhoto', 'url']) || item.getIn(['photos', 'main', 'url']);
}

CottageComplex.TYPE_SHORT = 'short';
CottageComplex.TYPE_FULL = 'full';

CottageComplex.prototype.getId = function () {
  return this.id;
};

CottageComplex.prototype.getName = function () {
  return this.name;
};

CottageComplex.prototype.getLabel = function (type = CottageComplex.TYPE_SHORT) {
  const typeName = type === CottageComplex.TYPE_FULL
    ? this.getType()
    : this.getTypeShort();

  return typeName + '\u00A0\u00AB' + this.name + '\u00BB';
};

CottageComplex.prototype.getType = function () {
  return this.typeName;
};

CottageComplex.prototype.getTypeShort = function () {
  return this.typeShortName;
};

CottageComplex.prototype.getUri = function () {
  return this.uri;
};

CottageComplex.prototype.getMainPhoto = function () {
  return this.mainPhoto;
};

CottageComplex.prototype.getAddress = function () {
  return this.address;
};

CottageComplex.prototype.getPrice = function () {
  return this.price;
};

CottageComplex.prototype.getDeadline = function () {
  return this.deadline;
};

export default CottageComplex;



// WEBPACK FOOTER //
// ./src/classes/announcement/cottageComplex.js